/**
`colorWhite`

White

Other aliases:

- `colorBackgroundBase1`
- `colorBorderNeutralEmphasisHighOnDark`
- `colorBorderOnImageEmphasisHigh`
- `colorBorderOnImageEmphasisHighOnDark`
- `colorObjectInput`
- `colorObjectNeutralEmphasisHighOnDark`
- `colorObjectOnImage`
- `colorObjectOnImageOnDark`
- `colorTextInverse`
- `colorTextNeutralPrimaryOnDark`
*/
const colorWhite = "hsl(0, 0%, 100%)";

/**
`colorBlack`

Black
*/
const colorBlack = "hsl(0, 0%, 0%)";

/**
`colorGray05`

Gravity Gray 05 (Lightest)

Other aliases:

- `colorBackgroundBase0`
- `colorBackgroundBase2`
- `colorObjectInactiveEmphasisLow`
- `colorObjectNeutralEmphasisLow`
- `colorObjectNeutralEmphasisNoneHover`
*/
const colorGray05 = "hsl(0, 0%, 96%)";

/**
`colorGray10`

Gravity Gray 10

Other aliases:

- `colorBackgroundBase3`
- `colorBorderNeutralEmphasisHighHoverOnDark`
- `colorObjectNeutralEmphasisHighHoverOnDark`
- `colorObjectNeutralEmphasisNonePress`
- `colorTextNeutralPrimaryHoverOnDark`
*/
const colorGray10 = "hsl(0, 0%, 91%)";

/**
`colorGray15`

Gravity Gray 15

Other aliases:

- `colorBackgroundBase4`
- `colorBorderNeutralEmphasisLow`
- `colorBorderNeutralEmphasisMediumPressOnDark`
- `colorObjectNeutralEmphasisHighPressOnDark`
- `colorObjectNeutralEmphasisLowHover`
- `colorTextNeutralPrimaryPressOnDark`
*/
const colorGray15 = "hsl(0, 0%, 83%)";

/**
`colorGray20`

Gravity Gray 20

Other aliases:

- `colorBorderInactive`
- `colorBorderNeutralEmphasisHighPressOnDark`
- `colorObjectInactiveEmphasisMedium`
- `colorObjectNeutralEmphasisMediumPressOnDark`
- `colorTextInactive`
- `colorTextNeutralSecondaryPressOnDark`
*/
const colorGray20 = "hsl(0, 0%, 75%)";

/**
`colorGray25`

Gravity Gray 25

Other aliases:

- `colorBorderNeutralEmphasisLowHover`
- `colorBorderNeutralEmphasisMediumHoverOnDark`
- `colorObjectNeutralEmphasisLowPress`
- `colorObjectNeutralEmphasisMediumHoverOnDark`
- `colorTextNeutralSecondaryHoverOnDark`
*/
const colorGray25 = "hsl(0, 0%, 71%)";

/**
`colorGray35`

Gravity Gray 35

Other aliases:

- `colorBorderDotNeutralOnDark`
- `colorBorderNeutralEmphasisLowPress`
- `colorBorderNeutralEmphasisMediumOnDark`
- `colorObjectDotNeutralOnDark`
- `colorObjectNeutralEmphasisMediumOnDark`
- `colorTextNeutralSecondaryOnDark`
- `colorTextPlaceholderOnDark`
*/
const colorGray35 = "hsl(0, 0%, 62%)";

/**
`colorGray45`

Gravity Gray 45

Other aliases:

- `colorObjectDotNeutral`
*/
const colorGray45 = "hsl(0, 0%, 51%)";

/**
`colorGray55`

Gravity Gray 55

Other aliases:

- `colorBorderNeutralEmphasisMedium`
- `colorObjectNeutralEmphasisMedium`
- `colorTextNeutralSecondary`
- `colorTextPlaceholder`
*/
const colorGray55 = "hsl(0, 0%, 43%)";

/**
`colorGray65`

Gravity Gray 65

Other aliases:

- `colorBorderDotNeutral`
- `colorBorderNeutralEmphasisLowPressOnDark`
- `colorBorderNeutralEmphasisMediumHover`
- `colorObjectNeutralEmphasisLowPressOnDark`
- `colorObjectNeutralEmphasisMediumHover`
- `colorTextNeutralSecondaryHover`
*/
const colorGray65 = "hsl(0, 0%, 32%)";

/**
`colorGray75`

Gravity Gray 75

Other aliases:

- `colorBackgroundBase4OnDark`
- `colorBorderInactiveOnDark`
- `colorBorderNeutralEmphasisHighPress`
- `colorBorderNeutralEmphasisLowHoverOnDark`
- `colorBorderNeutralEmphasisMediumPress`
- `colorObjectInactiveEmphasisMediumOnDark`
- `colorObjectNeutralEmphasisHighPress`
- `colorObjectNeutralEmphasisLowHoverOnDark`
- `colorObjectNeutralEmphasisMediumPress`
- `colorTextInactiveOnDark`
- `colorTextNeutralPrimaryPress`
- `colorTextNeutralSecondaryPress`
*/
const colorGray75 = "hsl(0, 0%, 24%)";

/**
`colorGray80`

Gravity Gray 80

Other aliases:

- `colorBackgroundBase3OnDark`
- `colorBorderNeutralEmphasisLowOnDark`
- `colorObjectNeutralEmphasisNonePressOnDark`
*/
const colorGray80 = "hsl(0, 0%, 21%)";

/**
`colorGray85`

Gravity Gray 85

Other aliases:

- `colorBackgroundBase2OnDark`
- `colorBorderNeutralEmphasisHighHover`
- `colorObjectNeutralEmphasisHighHover`
- `colorObjectNeutralEmphasisLowOnDark`
- `colorObjectNeutralEmphasisNoneHoverOnDark`
- `colorTextNeutralPrimaryHover`
*/
const colorGray85 = "hsl(0, 0%, 16%)";

/**
`colorGray90`

Gravity Gray 90

Other aliases:

- `colorBackgroundBase1OnDark`
- `colorObjectInactiveEmphasisLowOnDark`
- `colorObjectInputOnDark`
*/
const colorGray90 = "hsl(0, 0%, 12%)";

/**
`colorGray95`

Gravity Gray 95 (Darkest)

Other aliases:

- `colorBackgroundBase0OnDark`
- `colorBorderNeutralEmphasisHigh`
- `colorObjectNeutralEmphasisHigh`
- `colorTextInverseOnDark`
- `colorTextNeutralPrimary`
- `colorTextOnImageInverse`
- `colorTextOnImageInverseOnDark`
*/
const colorGray95 = "hsl(0, 0%, 7%)";

/**
`colorBlue05`

Gravity Blue 05 (Lightest)

Other aliases:

- `colorObjectInformationalEmphasisLow`
- `colorObjectInteractiveEmphasisLow`
- `colorObjectInteractiveEmphasisNoneFocus`
- `colorObjectInteractiveEmphasisNoneHover`
*/
const colorBlue05 = "hsl(201, 100%, 96%)";

/**
`colorBlue10`

Gravity Blue 10

Other aliases:

- `colorObjectInformationalEmphasisLowHover`
- `colorObjectInteractiveEmphasisLowHover`
- `colorObjectInteractiveEmphasisNonePress`
*/
const colorBlue10 = "hsl(200, 100%, 90%)";

/**
`colorBlue15`

Gravity Blue 15

Other aliases:

- `colorBorderInteractivePressOnDark`
- `colorObjectInformationalEmphasisLowPress`
- `colorObjectInteractiveEmphasisLowPress`
- `colorTextInformationalPressOnDark`
- `colorTextInteractivePressOnDark`
*/
const colorBlue15 = "hsl(200, 98%, 83%)";

/**
`colorBlue20`

Gravity Blue 20

Other aliases:

- `colorObjectInformationalEmphasisHighPressOnDark`
- `colorObjectInteractiveEmphasisHighPressOnDark`
*/
const colorBlue20 = "hsl(200, 98%, 75%)";

/**
`colorBlue25`

Gravity Blue 25

Other aliases:

- `colorBorderInteractiveHoverOnDark`
- `colorObjectInformationalEmphasisHighHoverOnDark`
- `colorObjectInteractiveEmphasisHighHoverOnDark`
- `colorTextInformationalHoverOnDark`
- `colorTextInteractiveHoverOnDark`
*/
const colorBlue25 = "hsl(200, 97%, 66%)";

/**
`colorBlue35`

Gravity Blue 35

Other aliases:

- `colorBorderDotInformationalOnDark`
- `colorBorderFocusOnDark`
- `colorBorderInteractiveOnDark`
- `colorObjectDotInformationalOnDark`
- `colorObjectInformationalEmphasisHighOnDark`
- `colorObjectInteractiveEmphasisHighOnDark`
- `colorTextInformationalOnDark`
- `colorTextInteractiveOnDark`
*/
const colorBlue35 = "hsl(200, 79%, 54%)";

/**
`colorBlue45`

Gravity Blue 45

Other aliases:

- `colorObjectDotInformational`
*/
const colorBlue45 = "hsl(200, 82%, 42%)";

/**
`colorBlue55`

Gravity Blue 55

Other aliases:

- `colorBorderFocus`
- `colorBorderInteractive`
- `colorObjectInformationalEmphasisHigh`
- `colorObjectInteractiveEmphasisHigh`
- `colorTextInformational`
- `colorTextInteractive`
*/
const colorBlue55 = "hsl(200, 100%, 33%)";

/**
`colorBlue65`

Gravity Blue 65

Other aliases:

- `colorBorderDotInformational`
- `colorBorderInteractiveHover`
- `colorObjectInformationalEmphasisHighHover`
- `colorObjectInteractiveEmphasisHighHover`
- `colorTextInformationalHover`
- `colorTextInteractiveHover`
*/
const colorBlue65 = "hsl(200, 98%, 26%)";

/**
`colorBlue75`

Gravity Blue 75

Other aliases:

- `colorBackgroundBrand`
- `colorBackgroundBrandOnDark`
- `colorBorderInteractivePress`
- `colorObjectInformationalEmphasisHighPress`
- `colorObjectInformationalEmphasisLowPressOnDark`
- `colorObjectInteractiveEmphasisHighPress`
- `colorObjectInteractiveEmphasisLowPressOnDark`
- `colorTextInformationalPress`
- `colorTextInteractivePress`
*/
const colorBlue75 = "hsl(200, 98%, 18%)";

/**
`colorBlue80`

Gravity Blue 80

Other aliases:

- `colorObjectInformationalEmphasisLowHoverOnDark`
- `colorObjectInteractiveEmphasisLowHoverOnDark`
- `colorObjectInteractiveEmphasisNonePressOnDark`
*/
const colorBlue80 = "hsl(199, 88%, 16%)";

/**
`colorBlue85`

Gravity Blue 85

Other aliases:

- `colorObjectInformationalEmphasisLowOnDark`
- `colorObjectInteractiveEmphasisLowOnDark`
- `colorObjectInteractiveEmphasisNoneFocusOnDark`
- `colorObjectInteractiveEmphasisNoneHoverOnDark`
*/
const colorBlue85 = "hsl(199, 75%, 14%)";

/**
`colorBlue90`

Gravity Blue 90
*/
const colorBlue90 = "hsl(201, 45%, 10%)";

/**
`colorBlue95`

Gravity Blue 95 (Darkest)
*/
const colorBlue95 = "hsl(206, 23%, 6%)";

/**
`colorRed05`

Gravity Red 05 (Lightest)

Other aliases:

- `colorObjectCriticalEmphasisLow`
- `colorObjectCriticalEmphasisNoneFocus`
- `colorObjectCriticalEmphasisNoneHover`
*/
const colorRed05 = "hsl(0, 100%, 97%)";

/**
`colorRed10`

Gravity Red 10

Other aliases:

- `colorObjectCriticalEmphasisLowHover`
- `colorObjectCriticalEmphasisNonePress`
*/
const colorRed10 = "hsl(0, 100%, 94%)";

/**
`colorRed15`

Gravity Red 15

Other aliases:

- `colorObjectCriticalEmphasisLowPress`
- `colorTextCriticalPressOnDark`
*/
const colorRed15 = "hsl(359, 100%, 89%)";

/**
`colorRed20`

Gravity Red 20

Other aliases:

- `colorBorderCriticalPressOnDark`
- `colorObjectCriticalEmphasisHighPressOnDark`
*/
const colorRed20 = "hsl(359, 100%, 86%)";

/**
`colorRed25`

Gravity Red 25

Other aliases:

- `colorBorderCriticalHoverOnDark`
- `colorObjectCriticalEmphasisHighHoverOnDark`
- `colorTextCriticalHoverOnDark`
*/
const colorRed25 = "hsl(359, 100%, 80%)";

/**
`colorRed35`

Gravity Red 35

Other aliases:

- `colorBorderCriticalOnDark`
- `colorBorderDotCriticalOnDark`
- `colorObjectCriticalEmphasisHighOnDark`
- `colorObjectDotCriticalOnDark`
- `colorTextCriticalOnDark`
*/
const colorRed35 = "hsl(359, 100%, 71%)";

/**
`colorRed45`

Gravity Red 45

Other aliases:

- `colorObjectDotCritical`
*/
const colorRed45 = "hsl(359, 75%, 59%)";

/**
`colorRed55`

Gravity Red 55

Other aliases:

- `colorBorderCritical`
- `colorObjectCriticalEmphasisHigh`
- `colorTextCritical`
*/
const colorRed55 = "hsl(359, 70%, 47%)";

/**
`colorRed65`

Gravity Red 65

Other aliases:

- `colorBorderCriticalHover`
- `colorBorderDotCritical`
- `colorObjectCriticalEmphasisHighHover`
- `colorTextCriticalHover`
*/
const colorRed65 = "hsl(359, 65%, 37%)";

/**
`colorRed75`

Gravity Red 75

Other aliases:

- `colorBorderCriticalPress`
- `colorObjectCriticalEmphasisHighPress`
- `colorObjectCriticalEmphasisLowPressOnDark`
- `colorTextCriticalPress`
*/
const colorRed75 = "hsl(359, 57%, 29%)";

/**
`colorRed80`

Gravity Red 80

Other aliases:

- `colorObjectCriticalEmphasisLowHoverOnDark`
- `colorObjectCriticalEmphasisNonePressOnDark`
*/
const colorRed80 = "hsl(359, 51%, 25%)";

/**
`colorRed85`

Gravity Red 85

Other aliases:

- `colorObjectCriticalEmphasisLowOnDark`
- `colorObjectCriticalEmphasisNoneFocusOnDark`
- `colorObjectCriticalEmphasisNoneHoverOnDark`
*/
const colorRed85 = "hsl(0, 39%, 18%)";

/**
`colorRed90`

Gravity Red 90
*/
const colorRed90 = "hsl(0, 30%, 14%)";

/**
`colorRed95`

Gravity Red 95 (Darkest)
*/
const colorRed95 = "hsl(0, 22%, 8%)";

/**
`colorGreen05`

Gravity Green 05 (Lightest)

Other aliases:

- `colorObjectFavorableEmphasisLow`
*/
const colorGreen05 = "hsl(108, 80%, 94%)";

/**
`colorGreen10`

Gravity Green 10

Other aliases:

- `colorObjectFavorableEmphasisLowHover`
*/
const colorGreen10 = "hsl(108, 77%, 85%)";

/**
`colorGreen15`

Gravity Green 15

Other aliases:

- `colorObjectFavorableEmphasisLowPress`
*/
const colorGreen15 = "hsl(108, 73%, 74%)";

/**
`colorGreen20`

Gravity Green 20

Other aliases:

- `colorBorderFavorablePressOnDark`
- `colorObjectFavorableEmphasisHighPressOnDark`
- `colorTextFavorablePressOnDark`
*/
const colorGreen20 = "hsl(107, 63%, 63%)";

/**
`colorGreen25`

Gravity Green 25

Other aliases:

- `colorBorderFavorableHoverOnDark`
- `colorObjectFavorableEmphasisHighHoverOnDark`
- `colorTextFavorableHoverOnDark`
*/
const colorGreen25 = "hsl(108, 60%, 55%)";

/**
`colorGreen35`

Gravity Green 35

Other aliases:

- `colorBorderDotFavorableOnDark`
- `colorBorderFavorableOnDark`
- `colorObjectDotFavorableOnDark`
- `colorObjectFavorableEmphasisHighOnDark`
- `colorTextFavorableOnDark`
*/
const colorGreen35 = "hsl(108, 61%, 44%)";

/**
`colorGreen45`

Gravity Green 45

Other aliases:

- `colorObjectDotFavorable`
*/
const colorGreen45 = "hsl(108, 76%, 33%)";

/**
`colorGreen55`

Gravity Green 55

Other aliases:

- `colorBorderFavorable`
- `colorObjectFavorableEmphasisHigh`
- `colorTextFavorable`
*/
const colorGreen55 = "hsl(108, 88%, 26%)";

/**
`colorGreen65`

Gravity Green 65

Other aliases:

- `colorBorderDotFavorable`
- `colorBorderFavorableHover`
- `colorObjectFavorableEmphasisHighHover`
- `colorTextFavorableHover`
*/
const colorGreen65 = "hsl(108, 81%, 21%)";

/**
`colorGreen75`

Gravity Green 75

Other aliases:

- `colorBorderFavorablePress`
- `colorObjectFavorableEmphasisHighPress`
- `colorObjectFavorableEmphasisLowPressOnDark`
- `colorTextFavorablePress`
*/
const colorGreen75 = "hsl(108, 79%, 15%)";

/**
`colorGreen80`

Gravity Green 80

Other aliases:

- `colorObjectFavorableEmphasisLowHoverOnDark`
*/
const colorGreen80 = "hsl(108, 73%, 13%)";

/**
`colorGreen85`

Gravity Green 85

Other aliases:

- `colorObjectFavorableEmphasisLowOnDark`
*/
const colorGreen85 = "hsl(107, 54%, 12%)";

/**
`colorGreen90`

Gravity Green 90
*/
const colorGreen90 = "hsl(112, 26%, 11%)";

/**
`colorGreen95`

Gravity Green 95 (Darkest)
*/
const colorGreen95 = "hsl(108, 33%, 6%)";

/**
`colorYellow05`

Gravity Yellow 05 (Lightest)

Other aliases:

- `colorObjectWarningEmphasisLow`
*/
const colorYellow05 = "hsl(46, 100%, 91%)";

/**
`colorYellow10`

Gravity Yellow 10

Other aliases:

- `colorBorderWarningPressOnDark`
- `colorObjectWarningEmphasisHighPressOnDark`
- `colorObjectWarningEmphasisLowHover`
- `colorTextWarningPressOnDark`
*/
const colorYellow10 = "hsl(46, 100%, 80%)";

/**
`colorYellow15`

Gravity Yellow 15

Other aliases:

- `colorBorderWarningHoverOnDark`
- `colorObjectWarningEmphasisHighHoverOnDark`
- `colorObjectWarningEmphasisLowPress`
- `colorTextWarningHoverOnDark`
*/
const colorYellow15 = "hsl(47, 95%, 67%)";

/**
`colorYellow20`

Gravity Yellow 20

Other aliases:

- `colorBorderDotWarningOnDark`
- `colorBorderWarningOnDark`
- `colorObjectDotWarning`
- `colorObjectDotWarningOnDark`
- `colorObjectWarningEmphasisHigh`
- `colorObjectWarningEmphasisHighOnDark`
- `colorTextWarningOnDark`
*/
const colorYellow20 = "hsl(47, 95%, 50%)";

/**
`colorYellow25`

Gravity Yellow 25

Other aliases:

- `colorObjectWarningEmphasisHighHover`
*/
const colorYellow25 = "hsl(44, 86%, 52%)";

/**
`colorYellow35`

Gravity Yellow 35

Other aliases:

- `colorObjectWarningEmphasisHighPress`
*/
const colorYellow35 = "hsl(44, 96%, 41%)";

/**
`colorYellow45`

Gravity Yellow 45

Other aliases:

- `colorBorderDotWarning`
*/
const colorYellow45 = "hsl(44, 99%, 33%)";

/**
`colorYellow55`

Gravity Yellow 55

Other aliases:

- `colorBorderWarning`
- `colorTextWarning`
*/
const colorYellow55 = "hsl(42, 100%, 28%)";

/**
`colorYellow65`

Gravity Yellow 65

Other aliases:

- `colorBorderWarningHover`
- `colorTextWarningHover`
*/
const colorYellow65 = "hsl(43, 100%, 21%)";

/**
`colorYellow75`

Gravity Yellow 75

Other aliases:

- `colorBorderWarningPress`
- `colorTextWarningPress`
*/
const colorYellow75 = "hsl(44, 100%, 15%)";

/**
`colorYellow80`

Gravity Yellow 80

Other aliases:

- `colorObjectWarningEmphasisLowHoverOnDark`
*/
const colorYellow80 = "hsl(44, 100%, 13%)";

/**
`colorYellow85`

Gravity Yellow 85

Other aliases:

- `colorObjectWarningEmphasisLowOnDark`
- `colorObjectWarningEmphasisLowPressOnDark`
*/
const colorYellow85 = "hsl(44, 100%, 10%)";

/**
`colorYellow90`

Gravity Yellow 90
*/
const colorYellow90 = "hsl(44, 100%, 8%)";

/**
`colorYellow95`

Gravity Yellow 95 (Darkest)
*/
const colorYellow95 = "hsl(43, 69%, 5%)";

/**
`colorPurple35`

Gravity Purple 35. Use for visited links only.

Other aliases:

- `colorTextVisitedOnDark`
*/
const colorPurple35 = "hsl(270, 75%, 73%)";

/**
`colorPurple55`

Gravity Purple 55. Use for visited links only.

Other aliases:

- `colorTextVisited`
*/
const colorPurple55 = "hsl(270, 61%, 54%)";

/**
`colorBackgroundBase0`

Use for the base background layer for an application

Alias of `colorGray05`
*/
const colorBackgroundBase0 = "hsl(0, 0%, 96%)";

/**
`colorBackgroundBase0OnDark`

Use for the base background layer for an application

Alias of `colorGray95`
*/
const colorBackgroundBase0OnDark = "hsl(0, 0%, 7%)";

/**
`colorBackgroundBase1`

Use for the background of the primary content layer for an application

Alias of `colorWhite`
*/
const colorBackgroundBase1 = "hsl(0, 0%, 100%)";

/**
`colorBackgroundBase1OnDark`

Use for the background of the primary content layer for an application

Alias of `colorGray90`
*/
const colorBackgroundBase1OnDark = "hsl(0, 0%, 12%)";

/**
`colorBackgroundBase2`

Use for content nested on `colorBackgroundBase1`

Alias of `colorGray05`
*/
const colorBackgroundBase2 = "hsl(0, 0%, 96%)";

/**
`colorBackgroundBase2OnDark`

Use for content nested on `colorBackgroundBase1OnDark`

Alias of `colorGray85`
*/
const colorBackgroundBase2OnDark = "hsl(0, 0%, 16%)";

/**
`colorBackgroundBase3`

Use for content nested on `colorBackgroundBase2`

Alias of `colorGray10`
*/
const colorBackgroundBase3 = "hsl(0, 0%, 91%)";

/**
`colorBackgroundBase3OnDark`

Use for content nested on `colorBackgroundBase2OnDark`

Alias of `colorGray80`
*/
const colorBackgroundBase3OnDark = "hsl(0, 0%, 21%)";

/**
`colorBackgroundBase4`

Use for content nested on `colorBackgroundBase3`

Alias of `colorGray15`
*/
const colorBackgroundBase4 = "hsl(0, 0%, 83%)";

/**
`colorBackgroundBase4OnDark`

Use for content nested on `colorBackgroundBase3OnDark`

Alias of `colorGray75`
*/
const colorBackgroundBase4OnDark = "hsl(0, 0%, 24%)";

/**
`colorBackgroundBrand`

Use as the background for displaying the Capital One logo on brand blue

Alias of `colorBlue75`
*/
const colorBackgroundBrand = "hsl(200, 98%, 18%)";

/**
`colorBackgroundBrandOnDark`

Use as the background for displaying the Capital One logo on brand blue

Alias of `colorBlue75`
*/
const colorBackgroundBrandOnDark = "hsl(200, 98%, 18%)";

/**
`colorBackgroundTransparent`

Used to explicity call our transparent backgrounds
*/
const colorBackgroundTransparent = "hsl(0, 0%, 0%)";

/**
`colorBackgroundTransparentOnDark`

Used to explicity call our transparent backgrounds
*/
const colorBackgroundTransparentOnDark = "hsl(0, 0%, 0%)";

/**
`colorBackgroundOverlayEmphasisHigh`

Used to explicity call our transparent backgrounds
*/
const colorBackgroundOverlayEmphasisHigh = "hsla(0, 0%, 0%, 0.5)";

/**
`colorBackgroundOverlayEmphasisHighOnDark`

Used to explicity call our transparent backgrounds
*/
const colorBackgroundOverlayEmphasisHighOnDark = "hsla(0, 0%, 0%, 0.6)";

/**
`colorBackgroundOverlayEmphasisLow`

Used to explicity call our transparent backgrounds
*/
const colorBackgroundOverlayEmphasisLow = "hsla(0, 0%, 0%, 0.2)";

/**
`colorBackgroundOverlayEmphasisLowOnDark`

Used to explicity call our transparent backgrounds
*/
const colorBackgroundOverlayEmphasisLowOnDark = "hsla(0, 0%, 0%, 0.4)";

/**
`colorBackgroundOnAnyImage`

Use as a mostly-opaque background for overlays
*/
const colorBackgroundOnAnyImage = "hsla(0, 0%, 0%, 0.55)";

/**
`colorBackgroundOnAnyImageOnDark`

Use as a mostly-opaque background for overlays
*/
const colorBackgroundOnAnyImageOnDark = "hsla(0, 0%, 0%, 0.55)";

/**
`colorObjectInteractiveEmphasisHigh`

Primary color for high-emphasis interactive objects, like Primary buttons

Alias of `colorBlue55`
*/
const colorObjectInteractiveEmphasisHigh = "hsl(200, 100%, 33%)";

/**
`colorObjectInteractiveEmphasisHighOnDark`

Primary color for high-emphasis interactive objects, like Primary buttons in dark theme

Alias of `colorBlue35`
*/
const colorObjectInteractiveEmphasisHighOnDark = "hsl(200, 79%, 54%)";

/**
`colorObjectInteractiveEmphasisHighHover`

Hover state for primary interactive objects.

Alias of `colorBlue65`
*/
const colorObjectInteractiveEmphasisHighHover = "hsl(200, 98%, 26%)";

/**
`colorObjectInteractiveEmphasisHighHoverOnDark`

Hover state for primary interactive objects in dark theme.

Alias of `colorBlue25`
*/
const colorObjectInteractiveEmphasisHighHoverOnDark = "hsl(200, 97%, 66%)";

/**
`colorObjectInteractiveEmphasisHighPress`

Pressed/Active state for primary interactive objects

Alias of `colorBlue75`
*/
const colorObjectInteractiveEmphasisHighPress = "hsl(200, 98%, 18%)";

/**
`colorObjectInteractiveEmphasisHighPressOnDark`

Pressed/Active state for primary interactive objects in dark theme

Alias of `colorBlue20`
*/
const colorObjectInteractiveEmphasisHighPressOnDark = "hsl(200, 98%, 75%)";

/**
`colorObjectInteractiveEmphasisLow`

Used for low-emphasis interactive objects

Alias of `colorBlue05`
*/
const colorObjectInteractiveEmphasisLow = "hsl(201, 100%, 96%)";

/**
`colorObjectInteractiveEmphasisLowOnDark`

Used for low-emphasis interactive objects in dark theme

Alias of `colorBlue85`
*/
const colorObjectInteractiveEmphasisLowOnDark = "hsl(199, 75%, 14%)";

/**
`colorObjectInteractiveEmphasisLowHover`

Hover state for low-emphasis interactive objects

Alias of `colorBlue10`
*/
const colorObjectInteractiveEmphasisLowHover = "hsl(200, 100%, 90%)";

/**
`colorObjectInteractiveEmphasisLowHoverOnDark`

Hover state for low-emphasis interactive objects in dark theme

Alias of `colorBlue80`
*/
const colorObjectInteractiveEmphasisLowHoverOnDark = "hsl(199, 88%, 16%)";

/**
`colorObjectInteractiveEmphasisLowPress`

Press/active state for low-emphasis interactive objects

Alias of `colorBlue15`
*/
const colorObjectInteractiveEmphasisLowPress = "hsl(200, 98%, 83%)";

/**
`colorObjectInteractiveEmphasisLowPressOnDark`

Press/active state for low-emphasis interactive objects in dark theme

Alias of `colorBlue75`
*/
const colorObjectInteractiveEmphasisLowPressOnDark = "hsl(200, 98%, 18%)";

/**
`colorObjectInteractiveEmphasisNone`

Used for interactive objects that start out transparent, like menu rows or tertiary buttons
*/
const colorObjectInteractiveEmphasisNone = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectInteractiveEmphasisNoneOnDark`

Used for interactive objects that start out transparent, like menu rows or tertiary buttons in dark theme
*/
const colorObjectInteractiveEmphasisNoneOnDark = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectInteractiveEmphasisNoneHover`

Used for hover state of interactive objects that start out transparent, like menu rows or tertiary buttons

Alias of `colorBlue05`
*/
const colorObjectInteractiveEmphasisNoneHover = "hsl(201, 100%, 96%)";

/**
`colorObjectInteractiveEmphasisNoneHoverOnDark`

Used for hover state of interactive objects that start out transparent, like menu rows or tertiary buttons in dark theme

Alias of `colorBlue85`
*/
const colorObjectInteractiveEmphasisNoneHoverOnDark = "hsl(199, 75%, 14%)";

/**
`colorObjectInteractiveEmphasisNonePress`

Used for press state of interactive objects that start out transparent, like menu rows or tertiary buttons

Alias of `colorBlue10`
*/
const colorObjectInteractiveEmphasisNonePress = "hsl(200, 100%, 90%)";

/**
`colorObjectInteractiveEmphasisNonePressOnDark`

Used for press state of interactive objects that start out transparent, like menu rows or tertiary buttons in dark theme

Alias of `colorBlue80`
*/
const colorObjectInteractiveEmphasisNonePressOnDark = "hsl(199, 88%, 16%)";

/**
`colorObjectInteractiveEmphasisNoneFocus`

Used for focus state of interactive objects that start out transparent, like menu rows or tertiary buttons

Alias of `colorBlue05`
*/
const colorObjectInteractiveEmphasisNoneFocus = "hsl(201, 100%, 96%)";

/**
`colorObjectInteractiveEmphasisNoneFocusOnDark`

Used for focus state of interactive objects that start out transparent, like menu rows or tertiary buttons in dark theme

Alias of `colorBlue85`
*/
const colorObjectInteractiveEmphasisNoneFocusOnDark = "hsl(199, 75%, 14%)";

/**
`colorObjectCriticalEmphasisHigh`

Primary color for high-emphasis critical objects, like critical buttons or badges

Alias of `colorRed55`
*/
const colorObjectCriticalEmphasisHigh = "hsl(359, 70%, 47%)";

/**
`colorObjectCriticalEmphasisHighOnDark`

Primary color for high-emphasis critical objects, like critical buttons or badges in dark theme

Alias of `colorRed35`
*/
const colorObjectCriticalEmphasisHighOnDark = "hsl(359, 100%, 71%)";

/**
`colorObjectCriticalEmphasisHighHover`

Hover state for high-emphasis critical interactive objects.

Alias of `colorRed65`
*/
const colorObjectCriticalEmphasisHighHover = "hsl(359, 65%, 37%)";

/**
`colorObjectCriticalEmphasisHighHoverOnDark`

Hover state for high-emphasis critical interactive objects in dark theme.

Alias of `colorRed25`
*/
const colorObjectCriticalEmphasisHighHoverOnDark = "hsl(359, 100%, 80%)";

/**
`colorObjectCriticalEmphasisHighPress`

Press/active state for high-emphasis critical interactive objects.

Alias of `colorRed75`
*/
const colorObjectCriticalEmphasisHighPress = "hsl(359, 57%, 29%)";

/**
`colorObjectCriticalEmphasisHighPressOnDark`

Press/active state for high-emphasis critical interactive objects in dark theme.

Alias of `colorRed20`
*/
const colorObjectCriticalEmphasisHighPressOnDark = "hsl(359, 100%, 86%)";

/**
`colorObjectCriticalEmphasisLow`

Used for low-emphasis critical objects, like low-emphasis badges.

Alias of `colorRed05`
*/
const colorObjectCriticalEmphasisLow = "hsl(0, 100%, 97%)";

/**
`colorObjectCriticalEmphasisLowOnDark`

Used for low-emphasis critical objects, like low-emphasis badges in dark theme.

Alias of `colorRed85`
*/
const colorObjectCriticalEmphasisLowOnDark = "hsl(0, 39%, 18%)";

/**
`colorObjectCriticalEmphasisLowHover`

Hover state for low-emphasis critical objects.

Alias of `colorRed10`
*/
const colorObjectCriticalEmphasisLowHover = "hsl(0, 100%, 94%)";

/**
`colorObjectCriticalEmphasisLowHoverOnDark`

Hover state for low-emphasis critical objects in dark theme.

Alias of `colorRed80`
*/
const colorObjectCriticalEmphasisLowHoverOnDark = "hsl(359, 51%, 25%)";

/**
`colorObjectCriticalEmphasisLowPress`

Press/active state for low-emphasis critical objects.

Alias of `colorRed15`
*/
const colorObjectCriticalEmphasisLowPress = "hsl(359, 100%, 89%)";

/**
`colorObjectCriticalEmphasisLowPressOnDark`

Press/active state for low-emphasis critical objects in dark theme.

Alias of `colorRed75`
*/
const colorObjectCriticalEmphasisLowPressOnDark = "hsl(359, 57%, 29%)";

/**
`colorObjectCriticalEmphasisNone`

Used for critical objects that start out transparent, like menu rows or tertiay buttons
*/
const colorObjectCriticalEmphasisNone = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectCriticalEmphasisNoneOnDark`

Used for critical objects that start out transparent, like menu rows or tertiay buttons in dark theme
*/
const colorObjectCriticalEmphasisNoneOnDark = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectCriticalEmphasisNoneHover`

Used for hover state of critical objects that start out transparent, like menu rows or tertiary buttons

Alias of `colorRed05`
*/
const colorObjectCriticalEmphasisNoneHover = "hsl(0, 100%, 97%)";

/**
`colorObjectCriticalEmphasisNoneHoverOnDark`

Used for hover state of critical objects that start out transparent, like menu rows or tertiary buttons in dark theme

Alias of `colorRed85`
*/
const colorObjectCriticalEmphasisNoneHoverOnDark = "hsl(0, 39%, 18%)";

/**
`colorObjectCriticalEmphasisNonePress`

Used for press/active state of critical objects that start out transparent, like menu rows or tertiary buttons

Alias of `colorRed10`
*/
const colorObjectCriticalEmphasisNonePress = "hsl(0, 100%, 94%)";

/**
`colorObjectCriticalEmphasisNonePressOnDark`

Used for press/active state of critical objects that start out transparent, like menu rows or tertiary buttons in dark theme

Alias of `colorRed80`
*/
const colorObjectCriticalEmphasisNonePressOnDark = "hsl(359, 51%, 25%)";

/**
`colorObjectCriticalEmphasisNoneFocus`

Used for focus state of critical objects that start out transparent and do not employ the standard focus ring, like menu rows

Alias of `colorRed05`
*/
const colorObjectCriticalEmphasisNoneFocus = "hsl(0, 100%, 97%)";

/**
`colorObjectCriticalEmphasisNoneFocusOnDark`

Used for focus state of critical objects that start out transparent and do not employ the standard focus ring, like menu rowsin dark theme

Alias of `colorRed85`
*/
const colorObjectCriticalEmphasisNoneFocusOnDark = "hsl(0, 39%, 18%)";

/**
`colorObjectFavorableEmphasisHigh`

Primary color for high-emphasis favorable objects, like badges

Alias of `colorGreen55`
*/
const colorObjectFavorableEmphasisHigh = "hsl(108, 88%, 26%)";

/**
`colorObjectFavorableEmphasisHighOnDark`

Primary color for high-emphasis favorable objects, like badges in dark theme

Alias of `colorGreen35`
*/
const colorObjectFavorableEmphasisHighOnDark = "hsl(108, 61%, 44%)";

/**
`colorObjectFavorableEmphasisHighHover`

Hover state high-emphasis favorable objects.

Alias of `colorGreen65`
*/
const colorObjectFavorableEmphasisHighHover = "hsl(108, 81%, 21%)";

/**
`colorObjectFavorableEmphasisHighHoverOnDark`

Hover state high-emphasis favorable objects in dark theme.

Alias of `colorGreen25`
*/
const colorObjectFavorableEmphasisHighHoverOnDark = "hsl(108, 60%, 55%)";

/**
`colorObjectFavorableEmphasisHighPress`

Press/active state high-emphasis favorable objects.

Alias of `colorGreen75`
*/
const colorObjectFavorableEmphasisHighPress = "hsl(108, 79%, 15%)";

/**
`colorObjectFavorableEmphasisHighPressOnDark`

Press/active state high-emphasis favorable objects in dark theme.

Alias of `colorGreen20`
*/
const colorObjectFavorableEmphasisHighPressOnDark = "hsl(107, 63%, 63%)";

/**
`colorObjectFavorableEmphasisLow`

Used for low-emphasis favorable objects, like low-empahsis badges

Alias of `colorGreen05`
*/
const colorObjectFavorableEmphasisLow = "hsl(108, 80%, 94%)";

/**
`colorObjectFavorableEmphasisLowOnDark`

Used for low-emphasis favorable objects, like low-empahsis badges in dark theme

Alias of `colorGreen85`
*/
const colorObjectFavorableEmphasisLowOnDark = "hsl(107, 54%, 12%)";

/**
`colorObjectFavorableEmphasisLowHover`

Hover state low-emphasis favorable objects.

Alias of `colorGreen10`
*/
const colorObjectFavorableEmphasisLowHover = "hsl(108, 77%, 85%)";

/**
`colorObjectFavorableEmphasisLowHoverOnDark`

Hover state low-emphasis favorable objects in dark theme.

Alias of `colorGreen80`
*/
const colorObjectFavorableEmphasisLowHoverOnDark = "hsl(108, 73%, 13%)";

/**
`colorObjectFavorableEmphasisLowPress`

Press/active state low-emphasis favorable objects.

Alias of `colorGreen15`
*/
const colorObjectFavorableEmphasisLowPress = "hsl(108, 73%, 74%)";

/**
`colorObjectFavorableEmphasisLowPressOnDark`

Press/active state low-emphasis favorable objects in dark theme.

Alias of `colorGreen75`
*/
const colorObjectFavorableEmphasisLowPressOnDark = "hsl(108, 79%, 15%)";

/**
`colorObjectWarningEmphasisHigh`

Used for high-emphasis warning/caution objects like badges.

Alias of `colorYellow20`
*/
const colorObjectWarningEmphasisHigh = "hsl(47, 95%, 50%)";

/**
`colorObjectWarningEmphasisHighOnDark`

Used for high-emphasis warning/caution objects like badges in dark theme.

Alias of `colorYellow20`
*/
const colorObjectWarningEmphasisHighOnDark = "hsl(47, 95%, 50%)";

/**
`colorObjectWarningEmphasisHighHover`

Hover state for high-emphasis warning objects

Alias of `colorYellow25`
*/
const colorObjectWarningEmphasisHighHover = "hsl(44, 86%, 52%)";

/**
`colorObjectWarningEmphasisHighHoverOnDark`

Hover state for high-emphasis warning objects in dark theme

Alias of `colorYellow15`
*/
const colorObjectWarningEmphasisHighHoverOnDark = "hsl(47, 95%, 67%)";

/**
`colorObjectWarningEmphasisHighPress`

Press/active state for high-emphasis warning objects

Alias of `colorYellow35`
*/
const colorObjectWarningEmphasisHighPress = "hsl(44, 96%, 41%)";

/**
`colorObjectWarningEmphasisHighPressOnDark`

Press/active state for high-emphasis warning objects in dark theme

Alias of `colorYellow10`
*/
const colorObjectWarningEmphasisHighPressOnDark = "hsl(46, 100%, 80%)";

/**
`colorObjectWarningEmphasisLow`

Used for low-emphasis warning objects like badges and alerts.

Alias of `colorYellow05`
*/
const colorObjectWarningEmphasisLow = "hsl(46, 100%, 91%)";

/**
`colorObjectWarningEmphasisLowOnDark`

Used for low-emphasis warning objects like badges and alerts in dark theme.

Alias of `colorYellow85`
*/
const colorObjectWarningEmphasisLowOnDark = "hsl(44, 100%, 10%)";

/**
`colorObjectWarningEmphasisLowHover`

Hover state for low-emphasis warning objects

Alias of `colorYellow10`
*/
const colorObjectWarningEmphasisLowHover = "hsl(46, 100%, 80%)";

/**
`colorObjectWarningEmphasisLowHoverOnDark`

Hover state for low-emphasis warning objects in dark theme

Alias of `colorYellow80`
*/
const colorObjectWarningEmphasisLowHoverOnDark = "hsl(44, 100%, 13%)";

/**
`colorObjectWarningEmphasisLowPress`

Press/active state for low-emphasis warning objects

Alias of `colorYellow15`
*/
const colorObjectWarningEmphasisLowPress = "hsl(47, 95%, 67%)";

/**
`colorObjectWarningEmphasisLowPressOnDark`

Press/active state for low-emphasis warning objects in dark theme

Alias of `colorYellow85`
*/
const colorObjectWarningEmphasisLowPressOnDark = "hsl(44, 100%, 10%)";

/**
`colorObjectInformationalEmphasisHigh`

Used for high-emphasis informational objects like badges.

Alias of `colorBlue55`
*/
const colorObjectInformationalEmphasisHigh = "hsl(200, 100%, 33%)";

/**
`colorObjectInformationalEmphasisHighOnDark`

Used for high-emphasis informational objects like badges in dark theme.

Alias of `colorBlue35`
*/
const colorObjectInformationalEmphasisHighOnDark = "hsl(200, 79%, 54%)";

/**
`colorObjectInformationalEmphasisHighHover`

Hover state for high-emphasis informational objects

Alias of `colorBlue65`
*/
const colorObjectInformationalEmphasisHighHover = "hsl(200, 98%, 26%)";

/**
`colorObjectInformationalEmphasisHighHoverOnDark`

Hover state for high-emphasis informational objects in dark theme

Alias of `colorBlue25`
*/
const colorObjectInformationalEmphasisHighHoverOnDark = "hsl(200, 97%, 66%)";

/**
`colorObjectInformationalEmphasisHighPress`

Press/active state for high-emphasis informational objects

Alias of `colorBlue75`
*/
const colorObjectInformationalEmphasisHighPress = "hsl(200, 98%, 18%)";

/**
`colorObjectInformationalEmphasisHighPressOnDark`

Press/active state for high-emphasis informational objects in dark theme

Alias of `colorBlue20`
*/
const colorObjectInformationalEmphasisHighPressOnDark = "hsl(200, 98%, 75%)";

/**
`colorObjectInformationalEmphasisLow`

Used for low-emphasis informational objects.

Alias of `colorBlue05`
*/
const colorObjectInformationalEmphasisLow = "hsl(201, 100%, 96%)";

/**
`colorObjectInformationalEmphasisLowOnDark`

Used for low-emphasis informational objects in dark theme.

Alias of `colorBlue85`
*/
const colorObjectInformationalEmphasisLowOnDark = "hsl(199, 75%, 14%)";

/**
`colorObjectInformationalEmphasisLowHover`

Hover state for low-emphasis informational objects.

Alias of `colorBlue10`
*/
const colorObjectInformationalEmphasisLowHover = "hsl(200, 100%, 90%)";

/**
`colorObjectInformationalEmphasisLowHoverOnDark`

Hover state for low-emphasis informational objects in dark theme.

Alias of `colorBlue80`
*/
const colorObjectInformationalEmphasisLowHoverOnDark = "hsl(199, 88%, 16%)";

/**
`colorObjectInformationalEmphasisLowPress`

Press/active state for low-emphasis informational objects.

Alias of `colorBlue15`
*/
const colorObjectInformationalEmphasisLowPress = "hsl(200, 98%, 83%)";

/**
`colorObjectInformationalEmphasisLowPressOnDark`

Press/active state for low-emphasis informational objects in dark theme.

Alias of `colorBlue75`
*/
const colorObjectInformationalEmphasisLowPressOnDark = "hsl(200, 98%, 18%)";

/**
`colorObjectNeutralEmphasisHigh`

Used for high-emphasis neutral objects, like Neutral buttons and badges.

Alias of `colorGray95`
*/
const colorObjectNeutralEmphasisHigh = "hsl(0, 0%, 7%)";

/**
`colorObjectNeutralEmphasisHighOnDark`

Used for high-emphasis neutral objects, like Neutral buttons and badges in dark theme.

Alias of `colorWhite`
*/
const colorObjectNeutralEmphasisHighOnDark = "hsl(0, 0%, 100%)";

/**
`colorObjectNeutralEmphasisHighHover`

Hover state for high-emphasis neutral interactive objects.

Alias of `colorGray85`
*/
const colorObjectNeutralEmphasisHighHover = "hsl(0, 0%, 16%)";

/**
`colorObjectNeutralEmphasisHighHoverOnDark`

Hover state for high-emphasis neutral interactive objects in dark theme.

Alias of `colorGray10`
*/
const colorObjectNeutralEmphasisHighHoverOnDark = "hsl(0, 0%, 91%)";

/**
`colorObjectNeutralEmphasisHighPress`

Press/active state for high-emphasis neutral interactive objects.

Alias of `colorGray75`
*/
const colorObjectNeutralEmphasisHighPress = "hsl(0, 0%, 24%)";

/**
`colorObjectNeutralEmphasisHighPressOnDark`

Press/active state for high-emphasis neutral interactive objects in dark theme.

Alias of `colorGray15`
*/
const colorObjectNeutralEmphasisHighPressOnDark = "hsl(0, 0%, 83%)";

/**
`colorObjectNeutralEmphasisMedium`

Used for medium-emphasis neutral objects, like Neutral buttons and badges.

Alias of `colorGray55`
*/
const colorObjectNeutralEmphasisMedium = "hsl(0, 0%, 43%)";

/**
`colorObjectNeutralEmphasisMediumOnDark`

Used for medium-emphasis neutral objects, like Neutral buttons and badges in dark theme.

Alias of `colorGray35`
*/
const colorObjectNeutralEmphasisMediumOnDark = "hsl(0, 0%, 62%)";

/**
`colorObjectNeutralEmphasisMediumHover`

Hover state for medium-emphasis neutral interactive objects.

Alias of `colorGray65`
*/
const colorObjectNeutralEmphasisMediumHover = "hsl(0, 0%, 32%)";

/**
`colorObjectNeutralEmphasisMediumHoverOnDark`

Hover state for medium-emphasis neutral interactive objects in dark theme.

Alias of `colorGray25`
*/
const colorObjectNeutralEmphasisMediumHoverOnDark = "hsl(0, 0%, 71%)";

/**
`colorObjectNeutralEmphasisMediumPress`

Press/active state for medium-emphasis neutral interactive objects.

Alias of `colorGray75`
*/
const colorObjectNeutralEmphasisMediumPress = "hsl(0, 0%, 24%)";

/**
`colorObjectNeutralEmphasisMediumPressOnDark`

Press/active state for medium-emphasis neutral interactive objects in dark theme.

Alias of `colorGray20`
*/
const colorObjectNeutralEmphasisMediumPressOnDark = "hsl(0, 0%, 75%)";

/**
`colorObjectNeutralEmphasisLow`

Used for low-emphasis neutral objects like badges and alerts.

Alias of `colorGray05`
*/
const colorObjectNeutralEmphasisLow = "hsl(0, 0%, 96%)";

/**
`colorObjectNeutralEmphasisLowOnDark`

Used for low-emphasis neutral objects like badges and alerts in dark theme.

Alias of `colorGray85`
*/
const colorObjectNeutralEmphasisLowOnDark = "hsl(0, 0%, 16%)";

/**
`colorObjectNeutralEmphasisLowHover`

Hover state for low-emphasis neutral objects.

Alias of `colorGray15`
*/
const colorObjectNeutralEmphasisLowHover = "hsl(0, 0%, 83%)";

/**
`colorObjectNeutralEmphasisLowHoverOnDark`

Hover state for low-emphasis neutral objects in dark theme.

Alias of `colorGray75`
*/
const colorObjectNeutralEmphasisLowHoverOnDark = "hsl(0, 0%, 24%)";

/**
`colorObjectNeutralEmphasisLowPress`

Press/active state for low-emphasis neutral objects.

Alias of `colorGray25`
*/
const colorObjectNeutralEmphasisLowPress = "hsl(0, 0%, 71%)";

/**
`colorObjectNeutralEmphasisLowPressOnDark`

Press/active state for low-emphasis neutral objects in dark theme.

Alias of `colorGray65`
*/
const colorObjectNeutralEmphasisLowPressOnDark = "hsl(0, 0%, 32%)";

/**
`colorObjectNeutralEmphasisNone`

Used for neutral objects that start out transparent, like tertiary buttons
*/
const colorObjectNeutralEmphasisNone = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectNeutralEmphasisNoneOnDark`

Used for neutral objects that start out transparent, like tertiary buttons in dark theme
*/
const colorObjectNeutralEmphasisNoneOnDark = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectNeutralEmphasisNoneHover`

Used for hover state of neutral objects that start out transparent, like tertiary buttons

Alias of `colorGray05`
*/
const colorObjectNeutralEmphasisNoneHover = "hsl(0, 0%, 96%)";

/**
`colorObjectNeutralEmphasisNoneHoverOnDark`

Used for hover state of neutral objects that start out transparent, like tertiary buttons in dark theme

Alias of `colorGray85`
*/
const colorObjectNeutralEmphasisNoneHoverOnDark = "hsl(0, 0%, 16%)";

/**
`colorObjectNeutralEmphasisNonePress`

Used for press/active state of neutral objects that start out transparent, like tertiary buttons

Alias of `colorGray10`
*/
const colorObjectNeutralEmphasisNonePress = "hsl(0, 0%, 91%)";

/**
`colorObjectNeutralEmphasisNonePressOnDark`

Used for press/active state of neutral objects that start out transparent, like tertiary buttons in dark theme

Alias of `colorGray80`
*/
const colorObjectNeutralEmphasisNonePressOnDark = "hsl(0, 0%, 21%)";

/**
`colorObjectInput`

Default background color for objects like inputs and dropdowns

Alias of `colorWhite`
*/
const colorObjectInput = "hsl(0, 0%, 100%)";

/**
`colorObjectInputOnDark`

Default background color for objects like inputs and dropdowns in dark theme

Alias of `colorGray90`
*/
const colorObjectInputOnDark = "hsl(0, 0%, 12%)";

/**
`colorObjectDotNeutral`

Neutral status dots, like the dot indicator.

Alias of `colorGray45`
*/
const colorObjectDotNeutral = "hsl(0, 0%, 51%)";

/**
`colorObjectDotNeutralOnDark`

Neutral status dots, like the dot indicator in dark theme.

Alias of `colorGray35`
*/
const colorObjectDotNeutralOnDark = "hsl(0, 0%, 62%)";

/**
`colorObjectDotInformational`

Informational status dots, like the dot indicator.

Alias of `colorBlue45`
*/
const colorObjectDotInformational = "hsl(200, 82%, 42%)";

/**
`colorObjectDotInformationalOnDark`

Informational status dots, like the dot indicator in dark theme.

Alias of `colorBlue35`
*/
const colorObjectDotInformationalOnDark = "hsl(200, 79%, 54%)";

/**
`colorObjectDotFavorable`

Favorable status dots, like the dot indicator.

Alias of `colorGreen45`
*/
const colorObjectDotFavorable = "hsl(108, 76%, 33%)";

/**
`colorObjectDotFavorableOnDark`

Favorable status dots, like the dot indicator in dark theme.

Alias of `colorGreen35`
*/
const colorObjectDotFavorableOnDark = "hsl(108, 61%, 44%)";

/**
`colorObjectDotWarning`

Warning status dots, like the dot indicator.

Alias of `colorYellow20`
*/
const colorObjectDotWarning = "hsl(47, 95%, 50%)";

/**
`colorObjectDotWarningOnDark`

Warning status dots, like the dot indicator in dark theme.

Alias of `colorYellow20`
*/
const colorObjectDotWarningOnDark = "hsl(47, 95%, 50%)";

/**
`colorObjectDotCritical`

Critical status dots, like the dot indicator.

Alias of `colorRed45`
*/
const colorObjectDotCritical = "hsl(359, 75%, 59%)";

/**
`colorObjectDotCriticalOnDark`

Critical status dots, like the dot indicator in dark theme.

Alias of `colorRed35`
*/
const colorObjectDotCriticalOnDark = "hsl(359, 100%, 71%)";

/**
`colorObjectInactiveEmphasisMedium`

Default color for inactive objects, like inactive checkboxes.

Alias of `colorGray20`
*/
const colorObjectInactiveEmphasisMedium = "hsl(0, 0%, 75%)";

/**
`colorObjectInactiveEmphasisMediumOnDark`

Default color for inactive objects, like inactive checkboxes in dark theme.

Alias of `colorGray75`
*/
const colorObjectInactiveEmphasisMediumOnDark = "hsl(0, 0%, 24%)";

/**
`colorObjectInactiveEmphasisLow`

Secondary color for inactive objects that may contain inactive text or icons, like inactive text inputs.

Alias of `colorGray05`
*/
const colorObjectInactiveEmphasisLow = "hsl(0, 0%, 96%)";

/**
`colorObjectInactiveEmphasisLowOnDark`

Secondary color for inactive objects that may contain inactive text or icons, like inactive text inputs in dark theme.

Alias of `colorGray90`
*/
const colorObjectInactiveEmphasisLowOnDark = "hsl(0, 0%, 12%)";

/**
`colorObjectOnImage`

For objects placed against images or colorful backgrounds that were deliberately designed

Alias of `colorWhite`
*/
const colorObjectOnImage = "hsl(0, 0%, 100%)";

/**
`colorObjectOnImageOnDark`

For objects placed against images or colorful backgrounds that were deliberately designed in dark theme

Alias of `colorWhite`
*/
const colorObjectOnImageOnDark = "hsl(0, 0%, 100%)";

/**
`colorObjectOnImageHover`

Hover state for objects placed against images or colorful backgrounds that were deliberately designed.
*/
const colorObjectOnImageHover = "hsla(0, 0%, 100%, 0.9)";

/**
`colorObjectOnImageHoverOnDark`

Hover state for objects placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorObjectOnImageHoverOnDark = "hsla(0, 0%, 100%, 0.9)";

/**
`colorObjectOnImagePress`

Press/active state for objects placed against images or colorful backgrounds that were deliberately designed.
*/
const colorObjectOnImagePress = "hsla(0, 0%, 100%, 0.8)";

/**
`colorObjectOnImagePressOnDark`

Press/active state for objects placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorObjectOnImagePressOnDark = "hsla(0, 0%, 100%, 0.8)";

/**
`colorObjectOnImageInactive`

Inactive state for objects placed against images or colorful backgrounds that were deliberately designed.
*/
const colorObjectOnImageInactive = "hsla(0, 0%, 100%, 0.2)";

/**
`colorObjectOnImageInactiveOnDark`

Inactive state for objects placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorObjectOnImageInactiveOnDark = "hsla(0, 0%, 100%, 0.2)";

/**
`colorObjectOnImageInverse`

Used for objects placed against images or colorful backgrounds that were deliberately designed, like tertiary buttons.
*/
const colorObjectOnImageInverse = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectOnImageInverseOnDark`

Used for objects placed against images or colorful backgrounds that were deliberately designed, like tertiary buttons in dark theme.
*/
const colorObjectOnImageInverseOnDark = "hsla(0, 0%, 0%, 0)";

/**
`colorObjectOnImageInverseHover`

Hover state for objects placed against images or colorful backgrounds that were deliberately designed, like tertiary buttons.
*/
const colorObjectOnImageInverseHover = "hsla(0, 0%, 0%, 0.15)";

/**
`colorObjectOnImageInverseHoverOnDark`

Hover state for objects placed against images or colorful backgrounds that were deliberately designed, like tertiary buttons in dark theme.
*/
const colorObjectOnImageInverseHoverOnDark = "hsla(0, 0%, 0%, 0.15)";

/**
`colorObjectOnImageInversePress`

Press/active state for objects placed against images or colorful backgrounds that were deliberately designed, like tertiary buttons.
*/
const colorObjectOnImageInversePress = "hsla(0, 0%, 0%, 0.3)";

/**
`colorObjectOnImageInversePressOnDark`

Press/active state for objects placed against images or colorful backgrounds that were deliberately designed, like tertiary buttons in dark theme.
*/
const colorObjectOnImageInversePressOnDark = "hsla(0, 0%, 0%, 0.3)";

/**
`colorObjectOnAnyImageInverse`

For objects placed against unpredictable image backgrounds. Any white content placed on top of it will pass 4.5:1 color contrast ratio.
*/
const colorObjectOnAnyImageInverse = "hsla(0, 0%, 0%, 0.55)";

/**
`colorObjectOnAnyImageInverseOnDark`

For objects placed against unpredictable image backgrounds. Any white content placed on top of it will pass 4.5:1 color contrast ratio in dark theme.
*/
const colorObjectOnAnyImageInverseOnDark = "hsla(0, 0%, 0%, 0.55)";

/**
`colorObjectOnAnyImageInverseHover`

Hover state for on-any-image-inverse objects.
*/
const colorObjectOnAnyImageInverseHover = "hsla(0, 0%, 0%, 0.65)";

/**
`colorObjectOnAnyImageInverseHoverOnDark`

Hover state for on-any-image-inverse objects in dark theme.
*/
const colorObjectOnAnyImageInverseHoverOnDark = "hsla(0, 0%, 0%, 0.65)";

/**
`colorObjectOnAnyImageInversePress`

Press/active state for on-any-image-inverse objects.
*/
const colorObjectOnAnyImageInversePress = "hsla(0, 0%, 0%, 0.75)";

/**
`colorObjectOnAnyImageInversePressOnDark`

Press/active state for on-any-image-inverse objects in dark theme.
*/
const colorObjectOnAnyImageInversePressOnDark = "hsla(0, 0%, 0%, 0.75)";

/**
`colorObjectOnAnyImageInverseInactive`

For inactive objects placed against unpredictable image backgrounds.
*/
const colorObjectOnAnyImageInverseInactive = "hsla(0, 0%, 0%, 0.2)";

/**
`colorObjectOnAnyImageInverseInactiveOnDark`

For inactive objects placed against unpredictable image backgrounds in dark theme.
*/
const colorObjectOnAnyImageInverseInactiveOnDark = "hsla(0, 0%, 0%, 0.2)";

/**
`colorBorderFavorable`

Used for favorable borders.

Alias of `colorGreen55`
*/
const colorBorderFavorable = "hsl(108, 88%, 26%)";

/**
`colorBorderFavorableOnDark`

Used for favorable borders in dark theme.

Alias of `colorGreen35`
*/
const colorBorderFavorableOnDark = "hsl(108, 61%, 44%)";

/**
`colorBorderFavorableHover`

Hover state for favorable borders

Alias of `colorGreen65`
*/
const colorBorderFavorableHover = "hsl(108, 81%, 21%)";

/**
`colorBorderFavorableHoverOnDark`

Hover state for favorable borders in dark theme

Alias of `colorGreen25`
*/
const colorBorderFavorableHoverOnDark = "hsl(108, 60%, 55%)";

/**
`colorBorderFavorablePress`

Press/active state for favorable borders.

Alias of `colorGreen75`
*/
const colorBorderFavorablePress = "hsl(108, 79%, 15%)";

/**
`colorBorderFavorablePressOnDark`

Press/active state for favorable borders in dark theme.

Alias of `colorGreen20`
*/
const colorBorderFavorablePressOnDark = "hsl(107, 63%, 63%)";

/**
`colorBorderWarning`

Used for warning/caution borders.

Alias of `colorYellow55`
*/
const colorBorderWarning = "hsl(42, 100%, 28%)";

/**
`colorBorderWarningOnDark`

Used for warning/caution borders in dark theme.

Alias of `colorYellow20`
*/
const colorBorderWarningOnDark = "hsl(47, 95%, 50%)";

/**
`colorBorderWarningHover`

Hover state for warning/caution borders.

Alias of `colorYellow65`
*/
const colorBorderWarningHover = "hsl(43, 100%, 21%)";

/**
`colorBorderWarningHoverOnDark`

Hover state for warning/caution borders in dark theme.

Alias of `colorYellow15`
*/
const colorBorderWarningHoverOnDark = "hsl(47, 95%, 67%)";

/**
`colorBorderWarningPress`

Press/active state for warning/caution borders.

Alias of `colorYellow75`
*/
const colorBorderWarningPress = "hsl(44, 100%, 15%)";

/**
`colorBorderWarningPressOnDark`

Press/active state for warning/caution borders in dark theme.

Alias of `colorYellow10`
*/
const colorBorderWarningPressOnDark = "hsl(46, 100%, 80%)";

/**
`colorBorderFocus`

Used specifically for keyboard focus borders.

Alias of `colorBlue55`
*/
const colorBorderFocus = "hsl(200, 100%, 33%)";

/**
`colorBorderFocusOnDark`

Used specifically for keyboard focus borders in dark theme.

Alias of `colorBlue35`
*/
const colorBorderFocusOnDark = "hsl(200, 79%, 54%)";

/**
`colorBorderInteractive`

Primary color used for interactive borders, like on selectable cards or secondary buttons.

Alias of `colorBlue55`
*/
const colorBorderInteractive = "hsl(200, 100%, 33%)";

/**
`colorBorderInteractiveOnDark`

Primary color used for interactive borders, like on selectable cards or secondary buttons in dark theme.

Alias of `colorBlue35`
*/
const colorBorderInteractiveOnDark = "hsl(200, 79%, 54%)";

/**
`colorBorderInteractiveHover`

Hover state for interactive borders.

Alias of `colorBlue65`
*/
const colorBorderInteractiveHover = "hsl(200, 98%, 26%)";

/**
`colorBorderInteractiveHoverOnDark`

Hover state for interactive borders in dark theme.

Alias of `colorBlue25`
*/
const colorBorderInteractiveHoverOnDark = "hsl(200, 97%, 66%)";

/**
`colorBorderInteractivePress`

Press/active state for interactive borders.

Alias of `colorBlue75`
*/
const colorBorderInteractivePress = "hsl(200, 98%, 18%)";

/**
`colorBorderInteractivePressOnDark`

Press/active state for interactive borders in dark theme.

Alias of `colorBlue15`
*/
const colorBorderInteractivePressOnDark = "hsl(200, 98%, 83%)";

/**
`colorBorderCritical`

Used for critical/danger borders.

Alias of `colorRed55`
*/
const colorBorderCritical = "hsl(359, 70%, 47%)";

/**
`colorBorderCriticalOnDark`

Used for critical/danger borders in dark theme.

Alias of `colorRed35`
*/
const colorBorderCriticalOnDark = "hsl(359, 100%, 71%)";

/**
`colorBorderCriticalHover`

Hover state for critical interactive borders.

Alias of `colorRed65`
*/
const colorBorderCriticalHover = "hsl(359, 65%, 37%)";

/**
`colorBorderCriticalHoverOnDark`

Hover state for critical interactive borders in dark theme.

Alias of `colorRed25`
*/
const colorBorderCriticalHoverOnDark = "hsl(359, 100%, 80%)";

/**
`colorBorderCriticalPress`

Press/active state for critical interactive borders.

Alias of `colorRed75`
*/
const colorBorderCriticalPress = "hsl(359, 57%, 29%)";

/**
`colorBorderCriticalPressOnDark`

Press/active state for critical interactive borders in dark theme.

Alias of `colorRed20`
*/
const colorBorderCriticalPressOnDark = "hsl(359, 100%, 86%)";

/**
`colorBorderInactive`

Used for inactive state borders.

Alias of `colorGray20`
*/
const colorBorderInactive = "hsl(0, 0%, 75%)";

/**
`colorBorderInactiveOnDark`

Used for inactive state borders in dark theme.

Alias of `colorGray75`
*/
const colorBorderInactiveOnDark = "hsl(0, 0%, 24%)";

/**
`colorBorderNeutralEmphasisHigh`

Emphasized border color, for elements like cards and dividers

Alias of `colorGray95`
*/
const colorBorderNeutralEmphasisHigh = "hsl(0, 0%, 7%)";

/**
`colorBorderNeutralEmphasisHighOnDark`

Emphasized border color, for elements like cards and dividers in dark theme

Alias of `colorWhite`
*/
const colorBorderNeutralEmphasisHighOnDark = "hsl(0, 0%, 100%)";

/**
`colorBorderNeutralEmphasisHighHover`

Hover state for high-emphasis neutral border

Alias of `colorGray85`
*/
const colorBorderNeutralEmphasisHighHover = "hsl(0, 0%, 16%)";

/**
`colorBorderNeutralEmphasisHighHoverOnDark`

Hover state for high-emphasis neutral border in dark theme

Alias of `colorGray10`
*/
const colorBorderNeutralEmphasisHighHoverOnDark = "hsl(0, 0%, 91%)";

/**
`colorBorderNeutralEmphasisHighPress`

Press/active state for high-emphasis neutral border

Alias of `colorGray75`
*/
const colorBorderNeutralEmphasisHighPress = "hsl(0, 0%, 24%)";

/**
`colorBorderNeutralEmphasisHighPressOnDark`

Press/active state for high-emphasis neutral border in dark theme

Alias of `colorGray20`
*/
const colorBorderNeutralEmphasisHighPressOnDark = "hsl(0, 0%, 75%)";

/**
`colorBorderNeutralEmphasisMedium`

Default border color, for elements like text inputs, checkboxes and dropdowns.

Alias of `colorGray55`
*/
const colorBorderNeutralEmphasisMedium = "hsl(0, 0%, 43%)";

/**
`colorBorderNeutralEmphasisMediumOnDark`

Default border color, for elements like text inputs, checkboxes and dropdowns in dark theme.

Alias of `colorGray35`
*/
const colorBorderNeutralEmphasisMediumOnDark = "hsl(0, 0%, 62%)";

/**
`colorBorderNeutralEmphasisMediumHover`

Hover state for medium-emphasis neutral border

Alias of `colorGray65`
*/
const colorBorderNeutralEmphasisMediumHover = "hsl(0, 0%, 32%)";

/**
`colorBorderNeutralEmphasisMediumHoverOnDark`

Hover state for medium-emphasis neutral border in dark theme

Alias of `colorGray25`
*/
const colorBorderNeutralEmphasisMediumHoverOnDark = "hsl(0, 0%, 71%)";

/**
`colorBorderNeutralEmphasisMediumPress`

Press/active state for medium-emphasis neutral border

Alias of `colorGray75`
*/
const colorBorderNeutralEmphasisMediumPress = "hsl(0, 0%, 24%)";

/**
`colorBorderNeutralEmphasisMediumPressOnDark`

Press/active state for medium-emphasis neutral border in dark theme

Alias of `colorGray15`
*/
const colorBorderNeutralEmphasisMediumPressOnDark = "hsl(0, 0%, 83%)";

/**
`colorBorderNeutralEmphasisLow`

Subtle border color, for elements like cards and dividers.

Alias of `colorGray15`
*/
const colorBorderNeutralEmphasisLow = "hsl(0, 0%, 83%)";

/**
`colorBorderNeutralEmphasisLowOnDark`

Subtle border color, for elements like cards and dividers in dark theme.

Alias of `colorGray80`
*/
const colorBorderNeutralEmphasisLowOnDark = "hsl(0, 0%, 21%)";

/**
`colorBorderNeutralEmphasisLowHover`

Hover state for low-emphasis neutral border

Alias of `colorGray25`
*/
const colorBorderNeutralEmphasisLowHover = "hsl(0, 0%, 71%)";

/**
`colorBorderNeutralEmphasisLowHoverOnDark`

Hover state for low-emphasis neutral border in dark theme

Alias of `colorGray75`
*/
const colorBorderNeutralEmphasisLowHoverOnDark = "hsl(0, 0%, 24%)";

/**
`colorBorderNeutralEmphasisLowPress`

Press/active state for low-emphasis neutral border

Alias of `colorGray35`
*/
const colorBorderNeutralEmphasisLowPress = "hsl(0, 0%, 62%)";

/**
`colorBorderNeutralEmphasisLowPressOnDark`

Press/active state for low-emphasis neutral border in dark theme

Alias of `colorGray65`
*/
const colorBorderNeutralEmphasisLowPressOnDark = "hsl(0, 0%, 32%)";

/**
`colorBorderDotNeutral`

For borders on neutral status dots, like the dot indicator.

Alias of `colorGray65`
*/
const colorBorderDotNeutral = "hsl(0, 0%, 32%)";

/**
`colorBorderDotNeutralOnDark`

For borders on neutral status dots, like the dot indicator in dark theme.

Alias of `colorGray35`
*/
const colorBorderDotNeutralOnDark = "hsl(0, 0%, 62%)";

/**
`colorBorderDotInformational`

For borders on informational status dots, like the dot indicator.

Alias of `colorBlue65`
*/
const colorBorderDotInformational = "hsl(200, 98%, 26%)";

/**
`colorBorderDotInformationalOnDark`

For borders on informational status dots, like the dot indicator in dark theme.

Alias of `colorBlue35`
*/
const colorBorderDotInformationalOnDark = "hsl(200, 79%, 54%)";

/**
`colorBorderDotFavorable`

For borders on favorable status dots, like the dot indicator.

Alias of `colorGreen65`
*/
const colorBorderDotFavorable = "hsl(108, 81%, 21%)";

/**
`colorBorderDotFavorableOnDark`

For borders on favorable status dots, like the dot indicator in dark theme.

Alias of `colorGreen35`
*/
const colorBorderDotFavorableOnDark = "hsl(108, 61%, 44%)";

/**
`colorBorderDotWarning`

For borders on warning status dots, like the dot indicator.

Alias of `colorYellow45`
*/
const colorBorderDotWarning = "hsl(44, 99%, 33%)";

/**
`colorBorderDotWarningOnDark`

For borders on favorable status dots, like the dot indicator in dark theme.

Alias of `colorYellow20`
*/
const colorBorderDotWarningOnDark = "hsl(47, 95%, 50%)";

/**
`colorBorderDotCritical`

For borders on critical status dots, like the dot indicator.

Alias of `colorRed65`
*/
const colorBorderDotCritical = "hsl(359, 65%, 37%)";

/**
`colorBorderDotCriticalOnDark`

For borders on favorable status dots, like the dot indicator in dark theme.

Alias of `colorRed35`
*/
const colorBorderDotCriticalOnDark = "hsl(359, 100%, 71%)";

/**
`colorBorderOnImageEmphasisHigh`

For borders placed against images or colorful backgrounds that were deliberately designed.

Alias of `colorWhite`
*/
const colorBorderOnImageEmphasisHigh = "hsl(0, 0%, 100%)";

/**
`colorBorderOnImageEmphasisHighOnDark`

For high-emphasis borders placed against images or colorful backgrounds that were deliberately designed in dark theme.

Alias of `colorWhite`
*/
const colorBorderOnImageEmphasisHighOnDark = "hsl(0, 0%, 100%)";

/**
`colorBorderOnImageEmphasisHighHover`

Hover state for high-emphasis borders placed against images or colorful backgrounds that were deliberately designed
*/
const colorBorderOnImageEmphasisHighHover = "hsla(0, 0%, 100%, 0.9)";

/**
`colorBorderOnImageEmphasisHighHoverOnDark`

Hover state for high-emphasis borders placed against images or colorful backgrounds that were deliberately designed in dark theme
*/
const colorBorderOnImageEmphasisHighHoverOnDark = "hsla(0, 0%, 100%, 0.9)";

/**
`colorBorderOnImageEmphasisHighPress`

Press/active state for high-emphasis borders placed against images or colorful backgrounds that were deliberately designed
*/
const colorBorderOnImageEmphasisHighPress = "hsla(0, 0%, 100%, 0.8)";

/**
`colorBorderOnImageEmphasisHighPressOnDark`

Press/active state for high-emphasis borders placed against images or colorful backgrounds that were deliberately designed in dark theme
*/
const colorBorderOnImageEmphasisHighPressOnDark = "hsla(0, 0%, 100%, 0.8)";

/**
`colorBorderOnImageEmphasisLow`

For low-emphasis borders placed against images or colorful backgrounds that were deliberately designed.
*/
const colorBorderOnImageEmphasisLow = "hsla(0, 0%, 100%, 0.2)";

/**
`colorBorderOnImageEmphasisLowOnDark`

For low-emphasis borders placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorBorderOnImageEmphasisLowOnDark = "hsla(0, 0%, 100%, 0.2)";

/**
`colorBorderOnImageEmphasisLowHover`

Hover state for low-emphasis borders placed against images or colorful backgrounds that were deliberately designed
*/
const colorBorderOnImageEmphasisLowHover = "hsla(0, 0%, 100%, 0.3)";

/**
`colorBorderOnImageEmphasisLowHoverOnDark`

Hover state for low-emphasis borders placed against images or colorful backgrounds that were deliberately designed in dark theme
*/
const colorBorderOnImageEmphasisLowHoverOnDark = "hsla(0, 0%, 100%, 0.3)";

/**
`colorBorderOnImageEmphasisLowPress`

Press/active state for low-emphasis borders placed against images or colorful backgrounds that were deliberately designed
*/
const colorBorderOnImageEmphasisLowPress = "hsla(0, 0%, 100%, 0.4)";

/**
`colorBorderOnImageEmphasisLowPressOnDark`

Press/active state for low-emphasis borders placed against images or colorful backgrounds that were deliberately designed in dark theme
*/
const colorBorderOnImageEmphasisLowPressOnDark = "hsla(0, 0%, 100%, 0.4)";

/**
`colorBorderOnImageInactive`

Inactive state for subtle borders placed against images or colorful backgrounds that were deliberately designed.
*/
const colorBorderOnImageInactive = "hsla(0, 0%, 100%, 0.2)";

/**
`colorBorderOnImageInactiveOnDark`

Inactive state for subtle borders placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorBorderOnImageInactiveOnDark = "hsla(0, 0%, 100%, 0.2)";

/**
`colorTextInverse`

Used for text and icons on dark objects and backgrounds, like buttons.

Alias of `colorWhite`
*/
const colorTextInverse = "hsl(0, 0%, 100%)";

/**
`colorTextInverseOnDark`

Used for text and icons on light objects and backgrounds, like buttons.

Alias of `colorGray95`
*/
const colorTextInverseOnDark = "hsl(0, 0%, 7%)";

/**
`colorTextFavorable`

Used for favorable text, like success messages.

Alias of `colorGreen55`
*/
const colorTextFavorable = "hsl(108, 88%, 26%)";

/**
`colorTextFavorableOnDark`

Used for favorable text, like success messages in dark theme.

Alias of `colorGreen35`
*/
const colorTextFavorableOnDark = "hsl(108, 61%, 44%)";

/**
`colorTextFavorableHover`

Hover state for favorable text and icons

Alias of `colorGreen65`
*/
const colorTextFavorableHover = "hsl(108, 81%, 21%)";

/**
`colorTextFavorableHoverOnDark`

Hover state for favorable text and icons in dark theme

Alias of `colorGreen25`
*/
const colorTextFavorableHoverOnDark = "hsl(108, 60%, 55%)";

/**
`colorTextFavorablePress`

Press/active state for favorable text and icons

Alias of `colorGreen75`
*/
const colorTextFavorablePress = "hsl(108, 79%, 15%)";

/**
`colorTextFavorablePressOnDark`

Press/active state for favorable text and icons in dark theme

Alias of `colorGreen20`
*/
const colorTextFavorablePressOnDark = "hsl(107, 63%, 63%)";

/**
`colorTextWarning`

Used for Warning/Caution text, like warning messages.

Alias of `colorYellow55`
*/
const colorTextWarning = "hsl(42, 100%, 28%)";

/**
`colorTextWarningOnDark`

Used for Warning/Caution text, like warning messages in dark theme.

Alias of `colorYellow20`
*/
const colorTextWarningOnDark = "hsl(47, 95%, 50%)";

/**
`colorTextWarningHover`

Hover state for Warning/Caution text and icons

Alias of `colorYellow65`
*/
const colorTextWarningHover = "hsl(43, 100%, 21%)";

/**
`colorTextWarningHoverOnDark`

Hover state for Warning/Caution text and icons in dark theme

Alias of `colorYellow15`
*/
const colorTextWarningHoverOnDark = "hsl(47, 95%, 67%)";

/**
`colorTextWarningPress`

Press/active state for Warning/Caution text and icons

Alias of `colorYellow75`
*/
const colorTextWarningPress = "hsl(44, 100%, 15%)";

/**
`colorTextWarningPressOnDark`

Press/active state for Warning/Caution text and icons in dark theme

Alias of `colorYellow10`
*/
const colorTextWarningPressOnDark = "hsl(46, 100%, 80%)";

/**
`colorTextInteractive`

Used for interactive text and icons, like text links and interactive UI icons.

Alias of `colorBlue55`
*/
const colorTextInteractive = "hsl(200, 100%, 33%)";

/**
`colorTextInteractiveOnDark`

Used for interactive text and icons, like text links and interactive UI icons in dark theme.

Alias of `colorBlue35`
*/
const colorTextInteractiveOnDark = "hsl(200, 79%, 54%)";

/**
`colorTextInteractiveHover`

Hover state for Interactive text and icons.

Alias of `colorBlue65`
*/
const colorTextInteractiveHover = "hsl(200, 98%, 26%)";

/**
`colorTextInteractiveHoverOnDark`

Hover state for Interactive text and icons in dark theme.

Alias of `colorBlue25`
*/
const colorTextInteractiveHoverOnDark = "hsl(200, 97%, 66%)";

/**
`colorTextInteractivePress`

Press/active state for Interactive text and icons.

Alias of `colorBlue75`
*/
const colorTextInteractivePress = "hsl(200, 98%, 18%)";

/**
`colorTextInteractivePressOnDark`

Press/active state for Interactive text and icons in dark theme.

Alias of `colorBlue15`
*/
const colorTextInteractivePressOnDark = "hsl(200, 98%, 83%)";

/**
`colorTextInformational`

Used for informational text and icons, in components like alerts and badges

Alias of `colorBlue55`
*/
const colorTextInformational = "hsl(200, 100%, 33%)";

/**
`colorTextInformationalOnDark`

Used for informational text and icons, in components like alerts and badges in dark theme

Alias of `colorBlue35`
*/
const colorTextInformationalOnDark = "hsl(200, 79%, 54%)";

/**
`colorTextInformationalHover`

Hover state for informational text

Alias of `colorBlue65`
*/
const colorTextInformationalHover = "hsl(200, 98%, 26%)";

/**
`colorTextInformationalHoverOnDark`

Hover state for informational text in dark theme

Alias of `colorBlue25`
*/
const colorTextInformationalHoverOnDark = "hsl(200, 97%, 66%)";

/**
`colorTextInformationalPress`

Press/active state for informational text

Alias of `colorBlue75`
*/
const colorTextInformationalPress = "hsl(200, 98%, 18%)";

/**
`colorTextInformationalPressOnDark`

Press/active state for informational text in dark theme

Alias of `colorBlue15`
*/
const colorTextInformationalPressOnDark = "hsl(200, 98%, 83%)";

/**
`colorTextCritical`

Used for critical/danger text and icons, like error messages.

Alias of `colorRed55`
*/
const colorTextCritical = "hsl(359, 70%, 47%)";

/**
`colorTextCriticalOnDark`

Used for critical/danger text and icons, like error messages in dark theme.

Alias of `colorRed35`
*/
const colorTextCriticalOnDark = "hsl(359, 100%, 71%)";

/**
`colorTextCriticalHover`

Hover state for Critical/Danger interactive text and icons.

Alias of `colorRed65`
*/
const colorTextCriticalHover = "hsl(359, 65%, 37%)";

/**
`colorTextCriticalHoverOnDark`

Hover state for Critical/Danger interactive text and icons in dark theme.

Alias of `colorRed25`
*/
const colorTextCriticalHoverOnDark = "hsl(359, 100%, 80%)";

/**
`colorTextCriticalPress`

Press/active state for Critical/Danger interactive text and icons.

Alias of `colorRed75`
*/
const colorTextCriticalPress = "hsl(359, 57%, 29%)";

/**
`colorTextCriticalPressOnDark`

Press/active state for Critical/Danger interactive text and icons in dark theme.

Alias of `colorRed15`
*/
const colorTextCriticalPressOnDark = "hsl(359, 100%, 89%)";

/**
`colorTextInactive`

Used for inactive text and icons.

Alias of `colorGray20`
*/
const colorTextInactive = "hsl(0, 0%, 75%)";

/**
`colorTextInactiveOnDark`

Used for inactive text and icons in dark theme.

Alias of `colorGray75`
*/
const colorTextInactiveOnDark = "hsl(0, 0%, 24%)";

/**
`colorTextNeutralPrimary`

Primary color used for text and icons.

Alias of `colorGray95`
*/
const colorTextNeutralPrimary = "hsl(0, 0%, 7%)";

/**
`colorTextNeutralPrimaryOnDark`

Primary color used for text and icons in dark theme.

Alias of `colorWhite`
*/
const colorTextNeutralPrimaryOnDark = "hsl(0, 0%, 100%)";

/**
`colorTextNeutralPrimaryHover`

Hover state for primary neutral text and icons

Alias of `colorGray85`
*/
const colorTextNeutralPrimaryHover = "hsl(0, 0%, 16%)";

/**
`colorTextNeutralPrimaryHoverOnDark`

Hover state for primary neutral text and icons in dark theme

Alias of `colorGray10`
*/
const colorTextNeutralPrimaryHoverOnDark = "hsl(0, 0%, 91%)";

/**
`colorTextNeutralPrimaryPress`

Press/active state for primary neutral text and icons

Alias of `colorGray75`
*/
const colorTextNeutralPrimaryPress = "hsl(0, 0%, 24%)";

/**
`colorTextNeutralPrimaryPressOnDark`

Press/active state for primary neutral text and icons in dark theme

Alias of `colorGray15`
*/
const colorTextNeutralPrimaryPressOnDark = "hsl(0, 0%, 83%)";

/**
`colorTextNeutralSecondary`

Secondary text and icon color. Used for both interactive and non-interactive neutral text and icons that require a bit less emphasis.

Alias of `colorGray55`
*/
const colorTextNeutralSecondary = "hsl(0, 0%, 43%)";

/**
`colorTextNeutralSecondaryOnDark`

Secondary text and icon color. Used for both interactive and non-interactive neutral text and icons that require a bit less emphasis in dark theme.

Alias of `colorGray35`
*/
const colorTextNeutralSecondaryOnDark = "hsl(0, 0%, 62%)";

/**
`colorTextNeutralSecondaryHover`

Hover state for secondary neutral text and icons.

Alias of `colorGray65`
*/
const colorTextNeutralSecondaryHover = "hsl(0, 0%, 32%)";

/**
`colorTextNeutralSecondaryHoverOnDark`

Hover state for secondary neutral text and icons in dark theme.

Alias of `colorGray25`
*/
const colorTextNeutralSecondaryHoverOnDark = "hsl(0, 0%, 71%)";

/**
`colorTextNeutralSecondaryPress`

Press/active state for secondary neutral text and icons.

Alias of `colorGray75`
*/
const colorTextNeutralSecondaryPress = "hsl(0, 0%, 24%)";

/**
`colorTextNeutralSecondaryPressOnDark`

Press/active state for secondary neutral text and icons in dark theme.

Alias of `colorGray20`
*/
const colorTextNeutralSecondaryPressOnDark = "hsl(0, 0%, 75%)";

/**
`colorTextPlaceholder`

Used specifically for placeholder text.

Alias of `colorGray55`
*/
const colorTextPlaceholder = "hsl(0, 0%, 43%)";

/**
`colorTextPlaceholderOnDark`

Used specifically for placeholder text in dark theme.

Alias of `colorGray35`
*/
const colorTextPlaceholderOnDark = "hsl(0, 0%, 62%)";

/**
`colorTextVisited`

@deprecated. Use `textInteractiveVisited` instead.

Alias of `colorPurple55`
*/
const colorTextVisited = "hsl(270, 61%, 54%)";

/**
`colorTextVisitedOnDark`

@deprecated. Use `textInteractiveVisitedOnDark` instead.

Alias of `colorPurple35`
*/
const colorTextVisitedOnDark = "hsl(270, 75%, 73%)";

/**
`colorTextOnImage`

For text placed against images or colorful backgrounds that were deliberately designed.
*/
const colorTextOnImage = "hsl(0, 0%, 100%)";

/**
`colorTextOnImageOnDark`

For text placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorTextOnImageOnDark = "hsl(0, 0%, 100%)";

/**
`colorTextOnImageHover`

Hover state for text placed against images or colorful backgrounds that were deliberately designed.
*/
const colorTextOnImageHover = "hsla(0, 0%, 100%, 0.9)";

/**
`colorTextOnImageHoverOnDark`

Hover state for text placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorTextOnImageHoverOnDark = "hsla(0, 0%, 100%, 0.9)";

/**
`colorTextOnImagePress`

Press/active state for text placed against images or colorful backgrounds that were deliberately designed.
*/
const colorTextOnImagePress = "hsla(0, 0%, 100%, 0.8)";

/**
`colorTextOnImagePressOnDark`

Press/active state for text placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorTextOnImagePressOnDark = "hsla(0, 0%, 100%, 0.8)";

/**
`colorTextOnImageInactive`

Inactive state for text placed against images or colorful backgrounds that were deliberately designed.
*/
const colorTextOnImageInactive = "hsla(0, 0%, 100%, 0.2)";

/**
`colorTextOnImageInactiveOnDark`

Inactive state for text placed against images or colorful backgrounds that were deliberately designed in dark theme.
*/
const colorTextOnImageInactiveOnDark = "hsla(0, 0%, 100%, 0.2)";

/**
`colorTextOnImageInverse`

For text within objects that are placed against images or color backgrounds, like labels on buttons

Alias of `colorGray95`
*/
const colorTextOnImageInverse = "hsl(0, 0%, 7%)";

/**
`colorTextOnImageInverseOnDark`

For text within objects that are placed against images or color backgrounds, like labels on buttons in dark theme

Alias of `colorGray95`
*/
const colorTextOnImageInverseOnDark = "hsl(0, 0%, 7%)";

/**
`colorTextOnImageInverseInactive`

For inactive text within objects that are placed against images or color backgrounds, like labels on buttons.
*/
const colorTextOnImageInverseInactive = "hsla(0, 0%, 0%, 0.5)";

/**
`colorTextOnImageInverseInactiveOnDark`

For inactive text within objects that are placed against images or color backgrounds, like labels on buttons in dark theme.
*/
const colorTextOnImageInverseInactiveOnDark = "hsla(0, 0%, 0%, 0.5)";

/**
`borderRadiusZero`
*/
const borderRadiusZero = "0px";

/**
`borderRadiusTiny`
*/
const borderRadiusTiny = "2px";

/**
`borderRadiusSmall`
*/
const borderRadiusSmall = "4px";

/**
`borderRadiusMedium`
*/
const borderRadiusMedium = "6px";

/**
`borderRadiusLarge`
*/
const borderRadiusLarge = "8px";

/**
`borderRadiusGiant`
*/
const borderRadiusGiant = "12px";

/**
`borderRadiusPill`
*/
const borderRadiusPill = "9999px";

export { borderRadiusGiant, borderRadiusLarge, borderRadiusMedium, borderRadiusPill, borderRadiusSmall, borderRadiusTiny, borderRadiusZero, colorBackgroundBase0, colorBackgroundBase0OnDark, colorBackgroundBase1, colorBackgroundBase1OnDark, colorBackgroundBase2, colorBackgroundBase2OnDark, colorBackgroundBase3, colorBackgroundBase3OnDark, colorBackgroundBase4, colorBackgroundBase4OnDark, colorBackgroundBrand, colorBackgroundBrandOnDark, colorBackgroundOnAnyImage, colorBackgroundOnAnyImageOnDark, colorBackgroundOverlayEmphasisHigh, colorBackgroundOverlayEmphasisHighOnDark, colorBackgroundOverlayEmphasisLow, colorBackgroundOverlayEmphasisLowOnDark, colorBackgroundTransparent, colorBackgroundTransparentOnDark, colorBlack, colorBlue05, colorBlue10, colorBlue15, colorBlue20, colorBlue25, colorBlue35, colorBlue45, colorBlue55, colorBlue65, colorBlue75, colorBlue80, colorBlue85, colorBlue90, colorBlue95, colorBorderCritical, colorBorderCriticalHover, colorBorderCriticalHoverOnDark, colorBorderCriticalOnDark, colorBorderCriticalPress, colorBorderCriticalPressOnDark, colorBorderDotCritical, colorBorderDotCriticalOnDark, colorBorderDotFavorable, colorBorderDotFavorableOnDark, colorBorderDotInformational, colorBorderDotInformationalOnDark, colorBorderDotNeutral, colorBorderDotNeutralOnDark, colorBorderDotWarning, colorBorderDotWarningOnDark, colorBorderFavorable, colorBorderFavorableHover, colorBorderFavorableHoverOnDark, colorBorderFavorableOnDark, colorBorderFavorablePress, colorBorderFavorablePressOnDark, colorBorderFocus, colorBorderFocusOnDark, colorBorderInactive, colorBorderInactiveOnDark, colorBorderInteractive, colorBorderInteractiveHover, colorBorderInteractiveHoverOnDark, colorBorderInteractiveOnDark, colorBorderInteractivePress, colorBorderInteractivePressOnDark, colorBorderNeutralEmphasisHigh, colorBorderNeutralEmphasisHighHover, colorBorderNeutralEmphasisHighHoverOnDark, colorBorderNeutralEmphasisHighOnDark, colorBorderNeutralEmphasisHighPress, colorBorderNeutralEmphasisHighPressOnDark, colorBorderNeutralEmphasisLow, colorBorderNeutralEmphasisLowHover, colorBorderNeutralEmphasisLowHoverOnDark, colorBorderNeutralEmphasisLowOnDark, colorBorderNeutralEmphasisLowPress, colorBorderNeutralEmphasisLowPressOnDark, colorBorderNeutralEmphasisMedium, colorBorderNeutralEmphasisMediumHover, colorBorderNeutralEmphasisMediumHoverOnDark, colorBorderNeutralEmphasisMediumOnDark, colorBorderNeutralEmphasisMediumPress, colorBorderNeutralEmphasisMediumPressOnDark, colorBorderOnImageEmphasisHigh, colorBorderOnImageEmphasisHighHover, colorBorderOnImageEmphasisHighHoverOnDark, colorBorderOnImageEmphasisHighOnDark, colorBorderOnImageEmphasisHighPress, colorBorderOnImageEmphasisHighPressOnDark, colorBorderOnImageEmphasisLow, colorBorderOnImageEmphasisLowHover, colorBorderOnImageEmphasisLowHoverOnDark, colorBorderOnImageEmphasisLowOnDark, colorBorderOnImageEmphasisLowPress, colorBorderOnImageEmphasisLowPressOnDark, colorBorderOnImageInactive, colorBorderOnImageInactiveOnDark, colorBorderWarning, colorBorderWarningHover, colorBorderWarningHoverOnDark, colorBorderWarningOnDark, colorBorderWarningPress, colorBorderWarningPressOnDark, colorGray05, colorGray10, colorGray15, colorGray20, colorGray25, colorGray35, colorGray45, colorGray55, colorGray65, colorGray75, colorGray80, colorGray85, colorGray90, colorGray95, colorGreen05, colorGreen10, colorGreen15, colorGreen20, colorGreen25, colorGreen35, colorGreen45, colorGreen55, colorGreen65, colorGreen75, colorGreen80, colorGreen85, colorGreen90, colorGreen95, colorObjectCriticalEmphasisHigh, colorObjectCriticalEmphasisHighHover, colorObjectCriticalEmphasisHighHoverOnDark, colorObjectCriticalEmphasisHighOnDark, colorObjectCriticalEmphasisHighPress, colorObjectCriticalEmphasisHighPressOnDark, colorObjectCriticalEmphasisLow, colorObjectCriticalEmphasisLowHover, colorObjectCriticalEmphasisLowHoverOnDark, colorObjectCriticalEmphasisLowOnDark, colorObjectCriticalEmphasisLowPress, colorObjectCriticalEmphasisLowPressOnDark, colorObjectCriticalEmphasisNone, colorObjectCriticalEmphasisNoneFocus, colorObjectCriticalEmphasisNoneFocusOnDark, colorObjectCriticalEmphasisNoneHover, colorObjectCriticalEmphasisNoneHoverOnDark, colorObjectCriticalEmphasisNoneOnDark, colorObjectCriticalEmphasisNonePress, colorObjectCriticalEmphasisNonePressOnDark, colorObjectDotCritical, colorObjectDotCriticalOnDark, colorObjectDotFavorable, colorObjectDotFavorableOnDark, colorObjectDotInformational, colorObjectDotInformationalOnDark, colorObjectDotNeutral, colorObjectDotNeutralOnDark, colorObjectDotWarning, colorObjectDotWarningOnDark, colorObjectFavorableEmphasisHigh, colorObjectFavorableEmphasisHighHover, colorObjectFavorableEmphasisHighHoverOnDark, colorObjectFavorableEmphasisHighOnDark, colorObjectFavorableEmphasisHighPress, colorObjectFavorableEmphasisHighPressOnDark, colorObjectFavorableEmphasisLow, colorObjectFavorableEmphasisLowHover, colorObjectFavorableEmphasisLowHoverOnDark, colorObjectFavorableEmphasisLowOnDark, colorObjectFavorableEmphasisLowPress, colorObjectFavorableEmphasisLowPressOnDark, colorObjectInactiveEmphasisLow, colorObjectInactiveEmphasisLowOnDark, colorObjectInactiveEmphasisMedium, colorObjectInactiveEmphasisMediumOnDark, colorObjectInformationalEmphasisHigh, colorObjectInformationalEmphasisHighHover, colorObjectInformationalEmphasisHighHoverOnDark, colorObjectInformationalEmphasisHighOnDark, colorObjectInformationalEmphasisHighPress, colorObjectInformationalEmphasisHighPressOnDark, colorObjectInformationalEmphasisLow, colorObjectInformationalEmphasisLowHover, colorObjectInformationalEmphasisLowHoverOnDark, colorObjectInformationalEmphasisLowOnDark, colorObjectInformationalEmphasisLowPress, colorObjectInformationalEmphasisLowPressOnDark, colorObjectInput, colorObjectInputOnDark, colorObjectInteractiveEmphasisHigh, colorObjectInteractiveEmphasisHighHover, colorObjectInteractiveEmphasisHighHoverOnDark, colorObjectInteractiveEmphasisHighOnDark, colorObjectInteractiveEmphasisHighPress, colorObjectInteractiveEmphasisHighPressOnDark, colorObjectInteractiveEmphasisLow, colorObjectInteractiveEmphasisLowHover, colorObjectInteractiveEmphasisLowHoverOnDark, colorObjectInteractiveEmphasisLowOnDark, colorObjectInteractiveEmphasisLowPress, colorObjectInteractiveEmphasisLowPressOnDark, colorObjectInteractiveEmphasisNone, colorObjectInteractiveEmphasisNoneFocus, colorObjectInteractiveEmphasisNoneFocusOnDark, colorObjectInteractiveEmphasisNoneHover, colorObjectInteractiveEmphasisNoneHoverOnDark, colorObjectInteractiveEmphasisNoneOnDark, colorObjectInteractiveEmphasisNonePress, colorObjectInteractiveEmphasisNonePressOnDark, colorObjectNeutralEmphasisHigh, colorObjectNeutralEmphasisHighHover, colorObjectNeutralEmphasisHighHoverOnDark, colorObjectNeutralEmphasisHighOnDark, colorObjectNeutralEmphasisHighPress, colorObjectNeutralEmphasisHighPressOnDark, colorObjectNeutralEmphasisLow, colorObjectNeutralEmphasisLowHover, colorObjectNeutralEmphasisLowHoverOnDark, colorObjectNeutralEmphasisLowOnDark, colorObjectNeutralEmphasisLowPress, colorObjectNeutralEmphasisLowPressOnDark, colorObjectNeutralEmphasisMedium, colorObjectNeutralEmphasisMediumHover, colorObjectNeutralEmphasisMediumHoverOnDark, colorObjectNeutralEmphasisMediumOnDark, colorObjectNeutralEmphasisMediumPress, colorObjectNeutralEmphasisMediumPressOnDark, colorObjectNeutralEmphasisNone, colorObjectNeutralEmphasisNoneHover, colorObjectNeutralEmphasisNoneHoverOnDark, colorObjectNeutralEmphasisNoneOnDark, colorObjectNeutralEmphasisNonePress, colorObjectNeutralEmphasisNonePressOnDark, colorObjectOnAnyImageInverse, colorObjectOnAnyImageInverseHover, colorObjectOnAnyImageInverseHoverOnDark, colorObjectOnAnyImageInverseInactive, colorObjectOnAnyImageInverseInactiveOnDark, colorObjectOnAnyImageInverseOnDark, colorObjectOnAnyImageInversePress, colorObjectOnAnyImageInversePressOnDark, colorObjectOnImage, colorObjectOnImageHover, colorObjectOnImageHoverOnDark, colorObjectOnImageInactive, colorObjectOnImageInactiveOnDark, colorObjectOnImageInverse, colorObjectOnImageInverseHover, colorObjectOnImageInverseHoverOnDark, colorObjectOnImageInverseOnDark, colorObjectOnImageInversePress, colorObjectOnImageInversePressOnDark, colorObjectOnImageOnDark, colorObjectOnImagePress, colorObjectOnImagePressOnDark, colorObjectWarningEmphasisHigh, colorObjectWarningEmphasisHighHover, colorObjectWarningEmphasisHighHoverOnDark, colorObjectWarningEmphasisHighOnDark, colorObjectWarningEmphasisHighPress, colorObjectWarningEmphasisHighPressOnDark, colorObjectWarningEmphasisLow, colorObjectWarningEmphasisLowHover, colorObjectWarningEmphasisLowHoverOnDark, colorObjectWarningEmphasisLowOnDark, colorObjectWarningEmphasisLowPress, colorObjectWarningEmphasisLowPressOnDark, colorPurple35, colorPurple55, colorRed05, colorRed10, colorRed15, colorRed20, colorRed25, colorRed35, colorRed45, colorRed55, colorRed65, colorRed75, colorRed80, colorRed85, colorRed90, colorRed95, colorTextCritical, colorTextCriticalHover, colorTextCriticalHoverOnDark, colorTextCriticalOnDark, colorTextCriticalPress, colorTextCriticalPressOnDark, colorTextFavorable, colorTextFavorableHover, colorTextFavorableHoverOnDark, colorTextFavorableOnDark, colorTextFavorablePress, colorTextFavorablePressOnDark, colorTextInactive, colorTextInactiveOnDark, colorTextInformational, colorTextInformationalHover, colorTextInformationalHoverOnDark, colorTextInformationalOnDark, colorTextInformationalPress, colorTextInformationalPressOnDark, colorTextInteractive, colorTextInteractiveHover, colorTextInteractiveHoverOnDark, colorTextInteractiveOnDark, colorTextInteractivePress, colorTextInteractivePressOnDark, colorTextInverse, colorTextInverseOnDark, colorTextNeutralPrimary, colorTextNeutralPrimaryHover, colorTextNeutralPrimaryHoverOnDark, colorTextNeutralPrimaryOnDark, colorTextNeutralPrimaryPress, colorTextNeutralPrimaryPressOnDark, colorTextNeutralSecondary, colorTextNeutralSecondaryHover, colorTextNeutralSecondaryHoverOnDark, colorTextNeutralSecondaryOnDark, colorTextNeutralSecondaryPress, colorTextNeutralSecondaryPressOnDark, colorTextOnImage, colorTextOnImageHover, colorTextOnImageHoverOnDark, colorTextOnImageInactive, colorTextOnImageInactiveOnDark, colorTextOnImageInverse, colorTextOnImageInverseInactive, colorTextOnImageInverseInactiveOnDark, colorTextOnImageInverseOnDark, colorTextOnImageOnDark, colorTextOnImagePress, colorTextOnImagePressOnDark, colorTextPlaceholder, colorTextPlaceholderOnDark, colorTextVisited, colorTextVisitedOnDark, colorTextWarning, colorTextWarningHover, colorTextWarningHoverOnDark, colorTextWarningOnDark, colorTextWarningPress, colorTextWarningPressOnDark, colorWhite, colorYellow05, colorYellow10, colorYellow15, colorYellow20, colorYellow25, colorYellow35, colorYellow45, colorYellow55, colorYellow65, colorYellow75, colorYellow80, colorYellow85, colorYellow90, colorYellow95 };
